import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const RestrictedAttrIcon = (props: SvgIconProps) => (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M10 6.667c1.767 0 3.278 1.039 3.889 2.5-.611 1.46-2.122 2.5-3.889 2.5s-3.279-1.039-3.89-2.5c.611-1.461 2.123-2.5 3.89-2.5Zm0 1.11c-1.083 0-2.089.546-2.639 1.39.55.844 1.556 1.389 2.639 1.389 1.083 0 2.089-.545 2.639-1.389-.55-.844-1.556-1.39-2.639-1.39Z" />
    <path d="M9.167 9.166a.832.832 0 1 0 1.667 0 .832.832 0 1 0-1.667 0Z" />
    <path d="m10 1.667-6.667 2.5v5.075c0 4.208 2.842 8.133 6.667 9.092 3.825-.959 6.666-4.884 6.666-9.092V4.167L10 1.667Zm5 7.575c0 3.333-2.125 6.417-5 7.358-2.875-.941-5-4.016-5-7.358V5.325l5-1.875 5 1.875v3.917Z" />
  </SvgIcon>
);

export default RestrictedAttrIcon;
